import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API_BASE_URL } from '../../../lib/constants';
import { useNotification } from '../../../contexts/NotificationContext';
import { backgroundImages } from '../constants/forgotPasswordConstants';

export const useForgotPassword = () => {
  const { showNotification } = useNotification();
  const [identifier, setIdentifier] = useState('');
  const [loading, setLoading] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex(prev =>
        prev === backgroundImages.length - 1 ? 0 : prev + 1);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const validate = () => {
    const tempErrors = {};
    if (!identifier.trim()) {
      tempErrors.identifier = 'Username or email is required';
    } else if (identifier.trim().length < 3) {
      tempErrors.identifier = 'Username or email too short';
    } else if (identifier.includes('@')) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(identifier)) {
        tempErrors.identifier = 'Invalid email address';
      }
    }
    setErrors(tempErrors);
    if (Object.keys(tempErrors).length > 0) {
      showNotification('error', Object.values(tempErrors)[0]);
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    if (e) e.preventDefault();
    if (!validate()) return;

    setLoading(true);
    try {
      const res = await axios.post(`${API_BASE_URL}/forgot_password`, { identifier });
      showNotification('success', res.data.message || 'Password reset link sent to your email.');
      navigate('/');
    } catch (err) {
      console.error('Forgot password error:', err);
      const msg = err.response?.data?.message || 'Failed to send reset link. User not found or server error.';
      showNotification('error', msg);
    } finally {
      setLoading(false);
    }
  };

  return {
    identifier,
    setIdentifier,
    loading,
    currentImageIndex,
    setCurrentImageIndex,
    errors,
    handleSubmit
  };
};
